import React from 'react';
import { useAutoOpenQuizFromUrl } from '../../lib/fiQuiz';

/**
 * Renders nothing; opens the quiz widget when the URL carries `?openQuiz=1` —
 * the landing half of the `/quiz` redirect (see `QuizRoute`).
 *
 * A component rather than a hook called from the PLP body so it mounts only
 * when the PLP actually renders: the PLP redirects away first for Mini-
 * unsupported countries and partner codes, and those visitors should not get a
 * quiz opening over the page they land on instead.
 */
export const QuizAutoOpen: React.FC = () => {
  useAutoOpenQuizFromUrl();
  return null;
};
